<template>
  <button
    type="button"
    :data-emphasis-identifier="id"
    :class="[
      'flex min-w-0 items-center gap-1 px-2 py-1',
      'select-none whitespace-nowrap text-sm font-medium no-underline',
      'rounded-full outline-2 outline-action transition focus-visible:outline',
      props.variant === 'default' &&
        'border border-transparent text-gray-700 hover:bg-gray-200 active:bg-gray-200 data-[state=open]:bg-gray-200 dark:text-muted-foreground dark:hover:bg-card dark:active:bg-card dark:data-[state=open]:bg-card',
    ]"
  >
    <span class="min-w-0">
      <slot></slot>
    </span>

    <ChevronDownIcon v-if="props.chevron" class="size-4 shrink-0" />
  </button>
</template>

<script setup lang="ts">
import ChevronDownIcon from "@/icons/heroicons/chevron-down-micro.svg";

const props = withDefaults(
  defineProps<{
    id?: string;
    variant?: "default";
    chevron?: boolean;
  }>(),
  {
    variant: "default",
    chevron: true,
  }
);
</script>
